import { PayloadAction } from '@reduxjs/toolkit';
import { IReportsSectionInitial } from './reportsSection.types';

export default {
  setIsGenerationReportShown(state: IReportsSectionInitial, { payload }: PayloadAction<boolean>) {
    state.generationReport.isReportShown = payload;
  },
  setGenerationStartedAt(state: IReportsSectionInitial, { payload }: PayloadAction<number>) {
    state.generationReport.startedAt = payload;
  },
  setGenerationFinishedAt(state: IReportsSectionInitial, { payload }: PayloadAction<number>) {
    state.generationReport.finishedAt = payload;
  },
  setGenerationIsTimedOut(state: IReportsSectionInitial, { payload }: PayloadAction<boolean>) {
    state.generationReport.isTimedOut = payload;
  },
  setIsSendingReportShown(state: IReportsSectionInitial, { payload }: PayloadAction<boolean>) {
    state.sendingReport.isReportShown = payload;
  },
  setSendingStartedAt(state: IReportsSectionInitial, { payload }: PayloadAction<number>) {
    state.sendingReport.startedAt = payload;
  },
  setSendingFinishedAt(state: IReportsSectionInitial, { payload }: PayloadAction<number>) {
    state.sendingReport.finishedAt = payload;
  },
  setSendingIsTimedOut(state: IReportsSectionInitial, { payload }: PayloadAction<boolean>) {
    state.sendingReport.isTimedOut = payload;
  },
};
